<template>
    <div v-if="$store.state.blacksmith" class="blacksmith">
        <div class="blacksmith__image" @click="goToUpgrades"></div>
    </div>
</template>

<script>
    export default {
        name: "Blacksmith",
        methods: {
            goToUpgrades() {
                this.$router.push("blacksmith")
            }
        }
    }
</script>

<style lang="scss" scoped>
    .blacksmith {
        &__image {
            width: 100%;
            height: 100%;
            cursor: pointer;
            background: url('../../assets/images/blacksmith.png') center center no-repeat;
            background-size: contain;
        }
    }
</style>